"use client";
import Hero from "./_components/hero";
import {
  FAQData,
  subscriptionPlans,
  TestimonialData,
} from "./_components/constants";
import SubscriptionCard from "./_components/subscriptionCard";
import FAQ from "home/faq";
import Testimonial from "./_components/testimonial";
import Steps from "./_components/Steps";
import StatusTrackCta from "./_components/statusTrackCta";
import { useEffect, useState } from "react";
import { ProductPlan } from "components/Payment/SubscriptionPlans";
import { fetchCountryCode } from "lib/utils/getCountryCode";
import { fetchDodoProductPlans } from "lib/utils/fetchDodoProductPlans";

const ResumeWritingClientPage = () => {
  const [loading, setLoading] = useState(false);
  const [countryCode, setCountryCode] = useState<string | null>(null);
  const [productPlans, setProductPlans] = useState<ProductPlan[]>();

  useEffect(() => {
    fetchCountryCode(setCountryCode);
    fetchDodoProductPlans(setProductPlans);
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100">
        <div className="relative h-16 w-16">
          <div className="absolute inset-0 animate-spin rounded-full border-4 border-b-blue-500 border-l-transparent border-r-transparent border-t-blue-500"></div>
          <div className="reverse-spin absolute inset-4 animate-spin rounded-full border-4 border-b-blue-500 border-l-transparent border-r-transparent border-t-blue-500"></div>
        </div>
      </div>
    );
  }
  return (
    <div className="space-y-16 py-10 font-montserrat">
      <Hero />

      <Steps />

      <StatusTrackCta />

      <div>
        <div className="mb-10 text-center text-[18px] font-medium text-[#071A34] md:text-[20.4px] lg:text-[27.2px] xl:text-[34px] 2xl:text-[40.8px]">
          Simple, easy pricing
        </div>
        {countryCode ? (
          <div
            className="grid grid-cols-1 gap-8 px-8 lg:grid-cols-3"
            id="plans"
          >
            {subscriptionPlans
              .filter((plan) => {
                if (countryCode === "IN") {
                  return plan.countryCode === "IN";
                }
                return plan.countryCode !== "IN";
              })
              .map((plan) => (
                <SubscriptionCard
                  id={plan.id}
                  key={plan.id}
                  level={plan.level}
                  experienceYears={plan.experienceYears}
                  price={plan.price}
                  deliverables={plan.deliverables}
                  setLoading={setLoading}
                  productPlans={productPlans!}
                  countryCode={countryCode}
                />
              ))}
          </div>
        ) : (
          <div className="mx-auto h-16 w-16 animate-spin rounded-full border-t-4 border-solid border-gray-300 border-t-blue-500" />
        )}
      </div>

      <div>
        <div className="mb-10 text-center text-[18px] font-medium text-[#071A34] md:text-[20.4px] lg:text-[27.2px] xl:text-[34px] 2xl:text-[40.8px]">
          See what our users say about us
        </div>
        <div className="flex flex-col items-center space-y-5">
          <div className="hidden min-w-max grid-cols-3 gap-5 md:grid">
            {TestimonialData.slice(0, 3).map((testimonial) => (
              <Testimonial
                key={testimonial.id}
                name={testimonial.name}
                testimonial={testimonial.testimonial}
                designation={testimonial.designation}
                avtar={testimonial.avtar}
              />
            ))}
          </div>
          <div className="grid min-w-max grid-cols-1 gap-5 overflow-x-auto md:grid-cols-4">
            {TestimonialData.slice(3, 7).map((testimonial) => (
              <Testimonial
                key={testimonial.id}
                name={testimonial.name}
                testimonial={testimonial.testimonial}
                designation={testimonial.designation}
                avtar={testimonial.avtar}
              />
            ))}
          </div>
          <div className="hidden min-w-max grid-cols-3 gap-5 md:grid">
            {TestimonialData.slice(7, 10).map((testimonial) => (
              <Testimonial
                key={testimonial.id}
                name={testimonial.name}
                testimonial={testimonial.testimonial}
                designation={testimonial.designation}
                avtar={testimonial.avtar}
              />
            ))}
          </div>
        </div>
      </div>

      <FAQ accordianList={FAQData} />
    </div>
  );
};

export default ResumeWritingClientPage;
